import { getters } from './store/getters';
import * as actions from './store/actions';
import { mutations } from './store/mutations';
import { state } from './store/inititalState';

export const menuGridGeneratorModule = {
  state,
  getters,
  actions,
  mutations
};
